export const fetchWorkflow = resp => {
  return {
    type: "FETCH_WORKFLOW",
    payload: resp
  };
};
export const initWorkflowList = () => {
  return {
    type: "INIT_WORKFLOW_LIST"
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/workflow.js